import React, { useState } from "react";
import "./Login.css";

function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Email:", email);
    console.log("Password:", password);

    // You can connect Firebase / API login here
  };

  return (
    <div className="login-container">

      <div className="login-box">

        <h2 className="login-title">Login to Heritage AI</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="email"
            placeholder="Email"
            className="login-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="login-button">
            Login
          </button>

        </form>

        <div className="login-links">
          <a href="#forgot-password">Forgot Password?</a>
          <span> | </span>
          <a href="#create-account">Create Account</a>
        </div>

      </div>

    </div>
  );
}

export default Login;